module.exports = __webpack_public_path__ + "img/2-3.cfa95673.png";